import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const FeatureOne = () => {
  const [categories, setCategories] = useState([]);

  function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
      <button
        type="button"
        onClick={onClick}
        className={`${className} slick-next slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
      >
        <i className="ph ph-caret-right" />
      </button>
    );
  }

  function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
      <button
        type="button"
        onClick={onClick}
        className={`${className} slick-prev slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
      >
        <i className="ph ph-caret-left" />
      </button>
    );
  }

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 10,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      { breakpoint: 1699, settings: { slidesToShow: 9 } },
      { breakpoint: 1599, settings: { slidesToShow: 8 } },
      { breakpoint: 1399, settings: { slidesToShow: 6 } },
      { breakpoint: 992, settings: { slidesToShow: 5 } },
      { breakpoint: 768, settings: { slidesToShow: 4 } },
      { breakpoint: 575, settings: { slidesToShow: 3 } },
      { breakpoint: 424, settings: { slidesToShow: 2 } },
      { breakpoint: 359, settings: { slidesToShow: 1 } },
    ],
  };
  const WC_URL = process.env.REACT_APP_WC_URL;
  const CK = process.env.REACT_APP_WC_CK;
  const CS = process.env.REACT_APP_WC_CS;



  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/categories/`
        );

        const data = await res.json();

        if (data.status) {
          setCategories(data.data);
          
        } else {
          console.error("Category fetch failed:", data.error);
        }
      } catch (err) {
        console.error("Category fetch error:", err);
      }
    };

    fetchCategories();
  }, []);

  return (
    <div className="feature" id="featureSection">
      <div className="container container-lg">
        <div className="position-relative arrow-center">
          <div className="feature-item-wrapper">
            {categories.length > 0 ? (
              <Slider {...settings}>
                {categories.map((cat) => (
                  <div key={cat.id} className="feature-item text-center">
                    <div className="feature-item__thumb rounded-circle mx-auto d-flex align-items-center justify-content-center overflow-hidden" style={{ width: "120px", height: "120px" }}>
                      <Link
                        to={`/shop?category=${cat.id}`}
                        className="w-100 h-100 d-flex align-items-center justify-content-center"
                      >
                        <img
                          src={cat.image?.src || "/assets/images/default.png"}
                          alt={cat.name}
                          className="img-fluid rounded-circle w-100 h-100 object-fit-cover"
                          style={{ objectFit: "cover" }}
                        />
                      </Link>
                    </div>

                    <div className="feature-item__content mt-3">
                      <p className="mb-2">
                        <Link
                          to={`/shop?category=${cat.id}`}
                          className="text-decoration-none text-dark fw-bold"
                        >
                          {cat.name}
                        </Link>
                      </p>
                      <span className="text-muted small">
                        {cat.count}+ Products
                      </span>
                    </div>
                  </div>

                ))}
              </Slider>
            ) : (
              <p style={{ textAlign: "center" }}>Loading categories...</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureOne;
